module.exports = __webpack_public_path__ + "static/media/magnifier.c00e3941.jpg";